import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormInputField} from '../../../entities/FormInputField';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {TestiService} from '../../../services/config/testi.service';
import {DropdownItem} from '../../../entities/DropdownItem';
import {StatusForm} from "../../../entities/statusForm";
import {TableGroups} from "../../../entities/TableGroups";
import {UtentiService} from "../../../services/utenti.service";
import {Utente} from "../../../entities/Utente";
import {FormResponse} from "../../../entities/FormResponse";
import {FormButton} from "../../../entities/Form";

@Component({
  selector: 'app-form-column-mod',
  templateUrl: './form-column-mod.component.html',
  styleUrls: ['./form-column-mod.component.scss']
})
export class FormColumnModComponent implements OnChanges, OnInit, OnDestroy {

  @Input() arrayFormInfo!: TableGroups[];
  @Input() formButton: FormButton;
  @Input() objValue?: any;
  @Input() selectsGroup?:  Map<string, DropdownItem[]> = new Map<string, DropdownItem[]>();
  @Input() enableFooter = true;
  @Input() groupValidator?: string;
  @Input() utenti?: Utente[];
  @Input() DragDropMaxHeight?: number;
  @Input() update?: boolean;
  @Input() msgForbidden?: string | '';
  @Input() showCancel?: boolean;
  @Input() showSave?: boolean;

  @Input() saveStyle?:string;
  @Input() cancelStyle?:string;

  @Output() saveForm = new EventEmitter();
  @Output() closeForm = new EventEmitter();
  @Output() cancel = new EventEmitter();

  @Output() updateForm = new EventEmitter();
  @Output() formState = new EventEmitter<StatusForm>();

  @Output() callback = new EventEmitter();

  msgs: any[] = [];

  formGroup!: FormGroup;
  testi: any;

  constructor( private formBuilder: FormBuilder,
               private testiService: TestiService,
               private utentiService: UtentiService)
{
    this.testi = this.testiService.componentRistorazione;
  }

  ngOnInit() {
    this.initFormGroup(this.arrayFormInfo);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['objValue'] && !!this.formGroup) {
      this.aggiornaForm();
    }
  }

  private initFormGroup(arrayFormInfo: TableGroups[]) {
    this.msgs = [];
    this.formGroup = this.formBuilder.group(this.buildFormControl(arrayFormInfo));
    this.setGroupValidators(this.groupValidator);

    /** update ofter any value change */
    this.formGroup.valueChanges.subscribe(
      data => {
        const objReturn = this.objValue;
        for ( const propertyName in this.formGroup!.value) {
          objReturn[propertyName] = this.formGroup!.value[propertyName];
        }

        this.updateForm.emit(objReturn);
      }
    );

    /** update ofter status change */

    this.formGroup.statusChanges
      .subscribe( res => this.formState.emit(res));
    setTimeout( () => this.formState.emit(this.formGroup.status as 'VALID' | 'INVALID' | 'PENDING' | 'DISABLED'), 100);

  }


  odd(n: number){
    if ( n % 2 === 0) {
      return false;
    } else {
      return true;
    }
  }

  private aggiornaForm() {
    this.arrayFormInfo.forEach( group => {
      group.groupItems.forEach(item => {
        this.formGroup!.get(item.prop)!.setValue(this.objValue[item.prop]);
      });
    });
  }

  private setGroupValidators(groupValidator: any) {
  }


  actionSave(type?: string) {
    const objReturn = this.objValue;
    for ( const propertyName in this.formGroup!.value) {
      objReturn[propertyName] = this.formGroup!.value[propertyName];
    }
    this.saveForm.emit(new FormResponse(type || 'save', objReturn));
  }

  actionCancel() {
    this.cancel.emit();
  }

  evaluate(group: any){
    let res=false;
    for (let item of group){
      if (item.type=='number'){
        res=true;
      }
    }
    return res;
  }


  private buildFormControl(arr: TableGroups[]) {
    const items: any = {};
    const group: any = {};

    arr.forEach(group => {
      group.groupItems.forEach(item => {
        items[item.prop] = this.objValue[item.prop] == null ? this.formControlNew(item) : this.formControlUpdate(item);
        items[item.prop].setValidators(this.makeValidators(item));
      });
    });

    if (this.objValue.id && !group['id'])  {
      items['id'] = new FormControl({value: this.objValue.id, disabled: true});
    }

    return items;
  }

  private formControlUpdate(item: FormInputField): FormControl {
    return new FormControl({value: this.objValue[item.prop], disabled: item.block});
  }

  private formControlNew(item: FormInputField): FormControl {
    return new FormControl({value: '', disabled: item.block ? item.block : false });
  }


  private makeValidators(item: FormInputField): Validators[] {
    let _array: Validators[] = [];
    item.validator && (_array = item.validator.map(itemVal => {this.msgs.push({prop: item['prop'], msg: itemVal['errorMsg']});
      return itemVal['value'];
    } ));
    item.required && _array.push(Validators.required);

    return _array;
  }

  validateRegexEmail(mail: string) {
    const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isValid = regex.test(mail);

    return !isValid;
  }

  cambioValore(event:any){
    this.callback.emit({type: "cambioValore", value: event})
  }

  ngOnDestroy(): void {
    if (this.formGroup) {
      // this.formGroup = undefined;
    }
  }

}

